import { useParams } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  Content,
  Tile,
} from "carbon-components-react";

import { BabyLeaveRecordTable } from ".";

export const BabyLeave = () => {
  const { bid } = useParams();

  return (
    <Content>
      <Breadcrumb>
        <BreadcrumbItem href="/care">護理管理</BreadcrumbItem>
        <BreadcrumbItem href={`/care/${bid}`}>新生兒護理明細</BreadcrumbItem>
        <BreadcrumbItem href="" isCurrentPage>
          新生兒離館紀錄
        </BreadcrumbItem>
      </Breadcrumb>

      <Tile>新生兒離館紀錄</Tile>

      <BabyLeaveRecordTable baby={bid} showWithBaby={false} />
    </Content>
  );
};
